var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3492 7.98416L6.14166 12.1917C5.78416 12.5492 5.78416 13.1267 6.14166 13.4842C6.49916 13.8417 7.07666 13.8417 7.43416 13.4842L11 9.92749L14.5567 13.4842C14.9142 13.8417 15.4917 13.8417 15.8492 13.4842C16.2067 13.1267 16.2067 12.5492 15.8492 12.1917L11.6417 7.98416C11.2933 7.62666 10.7067 7.62666 10.3492 7.98416Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpIcon);
export default __webpack_public_path__ + "static/media/ChevronUpIcon.5c72f2ca7141187d187500c092038cf5.svg";
export { ForwardRef as ReactComponent };